import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faRotateLeft } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";
import { SmartListSource } from "@/pages/Private/pages/List/schema/list";

import { SourceItem } from "./SourceItem";

interface AddedSourcesListProps {
	sources: SmartListSource[];
	onEdit: (source: SmartListSource) => void;
	onRemove: (source: SmartListSource) => void;
	removingId?: number | null;
}

export const AddedSourcesList: FunctionComponent<AddedSourcesListProps> = ({
	sources,
	onEdit,
	onRemove,
	removingId,
}) => {
	const { t } = useTranslation();
	const ts = (key: string) => t(`list.reengage.${key}`);

	return (
		<div className="bg-white border border-border rounded-xl p-6">
			<div className="text-base font-semibold text-text mb-1">{ts("addedSources")}</div>
			<div className="text-[13px] text-text-meta mb-5">{ts("addedSourcesSub")}</div>

			{sources.length === 0 ? (
				<div className="bg-white border border-dashed border-border rounded-xl py-12 px-6 text-center">
					<div className="w-10 h-10 mx-auto mb-3 rounded-full bg-background-light text-text-meta flex items-center justify-center">
						<Icon className="w-4 h-4" icon={faRotateLeft} />
					</div>
					<div className="text-sm font-semibold text-text mb-1">{ts("emptyTitle")}</div>
					<div className="text-[13px] text-text-meta">{ts("emptySub")}</div>
				</div>
			) : (
				sources.map((source) => (
					<SourceItem
						key={source.id}
						isRemoving={removingId === source.id}
						source={source}
						onEdit={onEdit}
						onRemove={onRemove}
					/>
				))
			)}
		</div>
	);
};
